const focus = {
  inserted: el => {
    el.focus();
  }
};

export default focus;



// WEBPACK FOOTER //
// ./src/directives/focus.directive.js